module.exports = __webpack_public_path__ + "img/app-academy-tutor-3.2a44f3fe.png";